// extracted by mini-css-extract-plugin
module.exports = {"PasswordReset":"PasswordReset_PasswordReset__2DGT3","Error":"PasswordReset_Error__1nfwv"};